import differenceWith from 'lodash/fp/differenceWith';
import isEqual from 'lodash/fp/isEqual';

export function objectsDifferences<T>(base: Partial<T>, tracked: Partial<T>): Partial<T> {
  const arrayOfDiff = differenceWith(isEqual, Object.entries(tracked), Object.entries(base));

  return Object.fromEntries(arrayOfDiff) as Partial<T>;
}
